/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Modifications terminées',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Apporter des modifications',
  'editor-common-extensibility.macro.button.configure': 'Configurer {macroName}',
  'editor.extension.legacyContentHeader': 'Contenu hérité',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Ce contenu a des fonctionnalités limitées,',
  'editor.extension.legacyContentHeader.learnMore': 'En savoir plus',
  'editor.trackChanges.toolbarIconLabel': 'Suivre les changements',
  'fablric.editor.viewAllInserts': 'Afficher tous les éléments insérables',
  'fabric.editor.action': 'Tâche',
  'fabric.editor.action.description': 'Créer et assigner des tâches',
  'fabric.editor.addAltText': 'Texte alternatif',
  'fabric.editor.addColumnLeft': 'Ajouter une colonne à gauche',
  'fabric.editor.addColumnRight': 'Ajouter une colonne à droite',
  'fabric.editor.addCommentOnMedia': 'Ajouter un commentaire',
  'fabric.editor.addImageBorder': 'Ajouter une bordure',
  'fabric.editor.addLoomVideo': 'Enregistrer une vidéo Loom',
  'fabric.editor.addLoomVideoComment': 'Enregistrez un commentaire vidéo Loom',
  'fabric.editor.addMediaFiles': 'Ajouter une image, une vidéo ou un fichier',
  'fabric.editor.addRowAbove': 'Ajouter une ligne au-dessus',
  'fabric.editor.addRowBelow': 'Ajouter une ligne en dessous',
  'fabric.editor.addUpdatedAltText': 'Ajoutez un texte de remplacement',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    "Utilisez Atlassian Intelligence pour trouver des éléments d'action et les afficher dans un panneau",
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': "Panneau des éléments d'action (bêta)",
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    "Utilisez Atlassian Intelligence pour résumer cette page et l'afficher dans un panneau",
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panneau de résumé de page (bêta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Contenu sélectionné',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Génère du contenu à insérer dans la mise à jour',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Résume le contenu de la mise à jour',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Générer',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Demandez à Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.edit': 'Modifier',
  'fabric.editor.ai.config.item.action.insert': 'Insérer',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Insérer en haut',
  'fabric.editor.ai.config.item.action.insertBelow': 'Insérer en dessous',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': "Insérer l'original en dessous",
  'fabric.editor.ai.config.item.action.replace': 'Remplacer',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Remplacer le titre',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Le titre ne peut pas dépasser {maxLength} caractères',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Continuer dans le chat',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Ouvrir dans le chat',
  'fabric.editor.ai.config.item.addPolish.description': 'Peaufine le contenu pour le rendre plus raffiné',
  'fabric.editor.ai.config.item.addPolish.title': 'Affiner',
  'fabric.editor.ai.config.item.agent.title': 'Agent Rovo Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Raccourcit le contenu pour le rendre plus concis',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Raccourcir la mise à jour',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Crée une description de pull request avec un résumé des changements',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Créer une description de pull request',
  'fabric.editor.ai.config.item.brainstorm.description': "Génère une liste d'idées pour un thème que vous proposez",
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Dites-moi le thème…',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorming',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorming',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Longueur',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Ajuster la longueur',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Applique un style décontracté au contenu',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Décontracté',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Décontracté',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Passer à un style décontracté',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Applique un style pédagogique au contenu',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Pédagogique',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Pédagogique',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Passer à un style pédagogique',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Applique un style empathique au contenu',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empathique',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empathique',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Passer à un style empathique',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Passer à un style…',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Applique un style neutre au contenu',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutre',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutre',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Passer à un style neutre',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Applique un style professionnel au contenu',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionnel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionnel',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Passer à un style professionnel',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Reformate le contenu en liste à puces',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Convertir en liste à puces',
  'fabric.editor.ai.config.item.convertToTable.description': 'Reformate le contenu en tableau avec des en-têtes',
  'fabric.editor.ai.config.item.convertToTable.title': 'Convertir en tableau',
  'fabric.editor.ai.config.item.draftReply.description':
    'Rédige une ébauche de réponse basée sur des tickets semblables à celui sur lequel vous travaillez',
  'fabric.editor.ai.config.item.draftReply.title': 'Rédiger une ébauche de réponse',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description':
    "Corrige les erreurs d'orthographe et de grammaire",
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Orthographe et grammaire',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': "Corriger l'orthographe et la grammaire",
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    "Améliore la clarté, la structure et le style pour améliorer l'engagement et la compréhension",
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': "Améliorer l'écriture",
  'fabric.editor.ai.config.item.enhance.improveWriting.title': "Améliorer l'écriture",
  'fabric.editor.ai.config.item.findActionItems.description': "Trouve les éléments d'action dans le contenu fourni",
  'fabric.editor.ai.config.item.findActionItems.title': "Rechercher des éléments d'action",
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Faites votre choix ci-dessous (la génération libre est désactivée dans Elevate pour le moment)',
  'fabric.editor.ai.config.item.generateContent.promptHint':
    "Écrivez avec AI ou sélectionnez l'une des options ci-dessous",
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Génère des notes de remontée en fonction du contexte du ticket',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Générer des notes de remontée',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Restructurez la description du ticket en fonction de son type',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Améliorer la description',
  'fabric.editor.ai.config.item.makeLonger.description':
    'Développe le contenu en fonction du contexte que vous fournissez',
  'fabric.editor.ai.config.item.makeLonger.title': 'Rallonger',
  'fabric.editor.ai.config.item.range.agent.description': 'Pas de description',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    "Demandez à l'agent d'écrire quelque chose ou choisissez parmi les options ci-dessous",
  'fabric.editor.ai.config.item.rephrase.description': 'Crée une suggestion pour réécrire vos phrases',
  'fabric.editor.ai.config.item.rephrase.title': 'Reformuler',
  'fabric.editor.ai.config.item.shorten.description': 'Raccourcit le contenu pour le rendre plus concis',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Raccourcir',
  'fabric.editor.ai.config.item.shorten.title': 'Raccourcir',
  'fabric.editor.ai.config.item.suggest.description': 'Suggère un titre pour le contenu fourni',
  'fabric.editor.ai.config.item.suggest.title': 'Suggérer un titre',
  'fabric.editor.ai.config.item.summarize.description':
    'Crée un résumé du texte sur lequel vous travaillez, en soulignant les points clés',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Résumer le texte',
  'fabric.editor.ai.config.item.summarize.title': 'Résumer le texte',
  'fabric.editor.ai.config.item.translate.czech': 'Tchèque',
  'fabric.editor.ai.config.item.translate.danish': 'Danois',
  'fabric.editor.ai.config.item.translate.dutch': 'Hollandais',
  'fabric.editor.ai.config.item.translate.english': 'Anglais',
  'fabric.editor.ai.config.item.translate.finnish': 'Finnois',
  'fabric.editor.ai.config.item.translate.french': 'Français',
  'fabric.editor.ai.config.item.translate.german': 'Allemand',
  'fabric.editor.ai.config.item.translate.hungarian': 'Hongrois',
  'fabric.editor.ai.config.item.translate.italian': 'Italien',
  'fabric.editor.ai.config.item.translate.japanese': 'Japonais',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Traduire',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Traduire en…',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norvégien',
  'fabric.editor.ai.config.item.translate.russian': 'Russe',
  'fabric.editor.ai.config.item.translate.spanish': 'Espagnol',
  'fabric.editor.ai.config.item.translate.swedish': 'Suédois',
  'fabric.editor.ai.config.item.translate.thai': 'Thaï',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Traduit le texte sur lequel vous travaillez en chinois (simplifié)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Traduire en chinois (simplifié)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Traduit le texte sur lequel vous travaillez en chinois (traditionnel)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Traduire en chinois (traditionnel)',
  'fabric.editor.ai.config.item.translateTo.czech.description':
    'Traduit le texte sur lequel vous travaillez en tchèque',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Traduire en tchèque',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Traduit le texte sur lequel vous travaillez en danois',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Traduire en danois',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Traduit le texte sur lequel vous travaillez en néerlandais',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Traduire en néerlandais',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Traduit le texte sur lequel vous travaillez en anglais',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Traduire en anglais',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Traduit le texte sur lequel vous travaillez en finnois',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Traduire en finnois',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Traduit le texte sur lequel vous travaillez en français',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Traduire en français',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Traduit le texte sur lequel vous travaillez en allemand',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Traduire en allemand',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Traduit le texte sur lequel vous travaillez en hongrois',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Traduire en hongrois',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Traduit le texte sur lequel vous travaillez en italien',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Traduire en italien',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Traduit le texte sur lequel vous travaillez en japonais',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Traduire en japonais',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Traduit le texte sur lequel vous travaillez en coréen',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Traduire en coréen',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Traduit le texte sur lequel vous travaillez en norvégien',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Traduire en norvégien',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Traduit le texte sur lequel vous travaillez en polonais',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Traduire en polonais',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Traduit le texte sur lequel vous travaillez en portugais (brésilien)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Traduire en portugais (brésilien)',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Traduit le texte sur lequel vous travaillez en russe',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Traduire en russe',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Traduit le texte sur lequel vous travaillez en espagnol',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Traduire en espagnol',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Traduit le texte sur lequel vous travaillez en suédois',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Traduire en suédois',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Traduit le texte sur lequel vous travaillez en thaï',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Traduire en thaï',
  'fabric.editor.ai.config.item.translateTo.turkish.description': 'Traduit le texte sur lequel vous travaillez en turc',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Traduire en turc',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Traduit le texte sur lequel vous travaillez en ukrainien',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Traduire en ukrainien',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Traduit le texte sur lequel vous travaillez en vietnamien',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Traduire en vietnamien',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Changer de ton',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Réécrire',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Traduire',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Titre de la page',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Page',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    'Nous rencontrons des problèmes et nous ne pouvons pas obtenir de réponse pour le moment. Réessayez ultérieurement.',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Nous rencontrons un problème pour insérer la réponse. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    "Nous rencontrons un problème pour générer l'aperçu. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    "Nous avons reçu trop de demandes récentes impliquant Atlassian Intelligence (AI). Réessayez dans quelques minutes ou découvrez-en plus sur <link>l'utilisation excessive d'AI</link>.",
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    "Impossible d'obtenir une réponse. Votre invite ou votre réponse a dépassé la limite fixée pour cette demande. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Nous rencontrons un problème. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.experience.adfStreamingError': "Toutes nos excuses, impossible d'obtenir une réponse.",
  'fabric.editor.ai.experience.apiError': "Impossible d'obtenir une réponse, veuillez réessayer.",
  'fabric.editor.ai.experience.aupViolationMessage':
    "Votre prompt ou votre contenu peut ne pas être conforme à notre Politique d'utilisation acceptable. Veuillez passer en revue les deux et consulter notre <link>Politique d'utilisation acceptable</link> si nécessaire. Si le problème persiste, essayez un autre prompt ou un autre contenu.",
  'fabric.editor.ai.experience.browseMore.agents': 'Rechercher des agents',
  'fabric.editor.ai.experience.cmdPaletteApiError': 'Une erreur est survenue lors de la génération de votre réponse.',
  'fabric.editor.ai.experience.cmdPaletteAupViolationMessage':
    "Nous n'avons pas pu traiter cette demande, car elle n'est pas conforme à notre <link>Politique d'utilisation acceptable</link>.",
  'fabric.editor.ai.experience.discardMessagePrompt': 'Souhaitez-vous abandonner votre invite ?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Souhaitez-vous abandonner votre réponse ?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'Annuler la demande et supprimer la réponse ?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'La génération libre est désactivée dans Elevate pour le moment.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Vous pouvez désormais coller des liens 🔗 vers du contenu Jira et Confluence dans vos prompts.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Optimisé par Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Génération',
  'fabric.editor.ai.experience.hipaaContentError':
    "Atlassian Intelligence n'a pas pu traiter votre demande, car votre contenu comprend des liens vers du contenu soumis à des restrictions HIPAA. Veuillez supprimer ces liens, puis réessayer.",
  'fabric.editor.ai.experience.inputTooShortError':
    'Le contenu est trop court pour être résumé. Veuillez ajouter du contenu, puis réessayez.',
  'fabric.editor.ai.experience.internalServerError':
    "Atlassian Intelligence (AI) ne répond pas. Réessayez plus tard ou <link>vérifiez l'état d'AI</link>.",
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Génération',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyse : examen de votre question.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Recherche : veuillez patienter pendant que nous recherchons des informations.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask':
    'Recherche : veuillez patienter pendant que nous recherchons dans Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration':
    'Recherche : veuillez patienter pendant que nous recherchons dans la page.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Aucun résultat',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    "Atlassian Intelligence n'a aucune suggestion pour le moment. N'hésitez pas à essayer une autre invite ou un autre contenu.",
  'fabric.editor.ai.experience.showMoreButton': 'Afficher plus',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Actions',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agents',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Source de connaissances',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agents Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agents Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Utiliser un agent Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Utiliser des connaissances générales',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Utiliser les connaissances de votre organisation',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    "Nous rencontrons un problème pour générer l'aperçu. Fermez la boîte de dialogue et réessayez.",
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Nous rencontrons un problème. Fermez la boîte de dialogue et réessayez.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Insérer en dessous',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Remplacer',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Les demandes de génération de contenu faisant référence à des URL sont disponibles en version bêta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip':
    'Mettez en valeur un terme, un acronyme ou une abréviation',
  'fabric.editor.ai.selectionToolbar.define.title': 'Définir',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Définir',
  'fabric.editor.ai.toolbar.askAI.title': 'Demander à AI',
  'fabric.editor.ai.toolbar.askRovo.title': 'Demander à Rovo',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Demandez à Rovo {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': "Demander à l'IA Rovo",
  'fabric.editor.ai.toolbar.changeTone.title': 'Changer de ton',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Options de changement de ton',
  'fabric.editor.ai.toolbar.improveWriting.title': "Améliorer l'écriture",
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    "Dire à Atlassian Intelligence d'améliorer l'écriture de votre sélection",
  'fabric.editor.ai.toolbar.makeLonger.title': 'Rallonger',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Raccourcir',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'Plus décontracté',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'Plus empathique',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'Plus professionnel',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': "Plus d'options Rovo",
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': "Corriger l'orthographe et la grammaire",
  'fabric.editor.ai.toolbar.summarize.title': 'Résumer',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Traduire',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Options de traduction',
  'fabric.editor.ai.toolbar.tryAI.title': 'Essayer Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Ouvrir Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Demander à AI : {key}+'",
  'fabric.editor.alignCenter': 'Aligner au centre',
  'fabric.editor.alignImageCenter': 'Aligner au centre',
  'fabric.editor.alignImageLeft': 'Aligner à gauche',
  'fabric.editor.alignImageRight': 'Aligner à droite',
  'fabric.editor.alignLeft': 'Aligner à gauche',
  'fabric.editor.alignRight': 'Aligner à droite',
  'fabric.editor.alignTableCenter': 'Aligner au centre',
  'fabric.editor.alignTableLeft': 'Aligner à gauche',
  'fabric.editor.alignment': 'Alignement du texte',
  'fabric.editor.altText': 'Texte de remplacement',
  'fabric.editor.alttext.validation':
    'Veuillez supprimer les éventuels caractères spéciaux dans le texte de remplacement.',
  'fabric.editor.annotationToolbar': "Barre d'outils d'annotation",
  'fabric.editor.backLink': 'Retour',
  'fabric.editor.backgroundColor': "Couleur d'arrière-plan",
  'fabric.editor.block.menu.codeblock': 'Bloc de code',
  'fabric.editor.block.menu.copy.block': 'Copier le bloc',
  'fabric.editor.block.menu.copy.link': 'Copier le lien',
  'fabric.editor.block.menu.delete.block': 'Supprimer',
  'fabric.editor.block.menu.layout': 'Disposition',
  'fabric.editor.block.menu.move.down': 'Déplacer vers le bas',
  'fabric.editor.block.menu.move.up': 'Déplacer vers le haut',
  'fabric.editor.block.menu.paragraph': 'Paragraphe',
  'fabric.editor.blockCardUnavailable': 'Le lien contextuel est dans {node} et sa vue ne peut être modifiée',
  'fabric.editor.blockControlDelete': 'Supprimer',
  'fabric.editor.blockControlDragHandleMove': 'Faire glisser pour déplacer',
  'fabric.editor.blockControlDragHandleRearrange': 'Glisser pour réorganiser',
  'fabric.editor.blockControlInsert': 'Insérer',
  'fabric.editor.blockControlMoveDown': 'Déplacer vers le bas',
  'fabric.editor.blockControlMoveLeft': 'Déplacer vers la gauche',
  'fabric.editor.blockControlMoveRight': 'Déplacer vers la droite',
  'fabric.editor.blockControlMoveUp': 'Déplacer vers le haut',
  'fabric.editor.blockControlMovedDown': 'Le contenu a été déplacé vers le bas',
  'fabric.editor.blockControlMovedUp': 'Le contenu a été déplacé vers le haut',
  'fabric.editor.blockDescription':
    "Affichez plus d'informations concernant un lien, y compris un résumé et des actions",
  'fabric.editor.blockTitle': 'Carte',
  'fabric.editor.blockquote': 'une citation',
  'fabric.editor.blockquote.description': 'Insérer une citation',
  'fabric.editor.blockquote2': 'Citation',
  'fabric.editor.bold': 'Gras',
  'fabric.editor.breakout.resizeCodeBlock': 'Redimensionner le snippet de code',
  'fabric.editor.breakout.resizeElement': "Redimensionner l'élément",
  'fabric.editor.breakout.resizeExpand': 'Redimensionner la section extensible',
  'fabric.editor.breakout.resizeLayout': 'Redimensionner la disposition',
  'fabric.editor.breakoutFullWidthLabel': 'Pleine largeur',
  'fabric.editor.breakoutWideWidthLabel': 'Large',
  'fabric.editor.bug': 'Bug',
  'fabric.editor.bulletedList': 'Liste à puces',
  'fabric.editor.canNotSortTable': '⚠️ Impossible de trier un tableau comportant des cellules fusionnées',
  'fabric.editor.cancelButton': 'Annuler',
  'fabric.editor.captionPlaceholder': 'Ajouter une légende',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Ajouter une légende : cliquez deux fois pour prévisualiser',
  'fabric.editor.cardFloatingControls': 'Options de carte',
  'fabric.editor.cellBackground': 'Arrière-plan de la cellule',
  'fabric.editor.cellOptions': 'Options de la cellule',
  'fabric.editor.checkUncheckActionItem': "Activer/Désactiver l'élément d'action",
  'fabric.editor.clearAltTextEdit': 'Effacer le texte alternatif',
  'fabric.editor.clearCells': '{0, plural, one {Effacer la cellule} other {Effacer les cellules}}',
  'fabric.editor.clearFormatting': 'Effacer la mise en forme',
  'fabric.editor.clearLink': 'Effacer le lien',
  'fabric.editor.clearLinkText': 'Effacer le texte',
  'fabric.editor.closeAltTextEdit': 'Retour',
  'fabric.editor.closeFindReplaceDialog': 'Fermer',
  'fabric.editor.closeHelpDialog': "Fermer la boîte de dialogue d'aide",
  'fabric.editor.code': 'Code',
  'fabric.editor.code.on': '{textFormattingOff}, code activé',
  'fabric.editor.codeBidiWarningLabel':
    "Les caractères bidirectionnels changent l'ordre de rendu du texte. Ils peuvent être utilisés pour masquer du code malveillant.",
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Copié !',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Copier en tant que texte',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': "Désactiver l'enveloppe",
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': "Activer l'enveloppe",
  'fabric.editor.codeblock': 'Extrait de code (snippet)',
  'fabric.editor.codeblock.description': 'Insérer du code avec coloration syntaxique',
  'fabric.editor.collapseNode': 'Réduire le contenu',
  'fabric.editor.collapseTable': 'Réduire le tableau',
  'fabric.editor.colorPicker.menuLabel': "Menu de l'outil pipette",
  'fabric.editor.columnDragHandle': 'Options de colonne',
  'fabric.editor.columnMovedLeft': 'Colonne déplacée vers la gauche à la position {index} sur {total}',
  'fabric.editor.columnMovedRight': 'Colonne déplacée vers la droite à la position {index} sur {total}',
  'fabric.editor.columnSelected': 'Colonne {index} sur {total} sélectionnée',
  'fabric.editor.columns': 'Mises en page',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Insérer {numberOfColumns} colonne uniforme} other {Insérer {numberOfColumns} colonnes uniformes}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Insérer une disposition en colonne unique',
  'fabric.editor.columns.description': 'Organiser votre page en sections',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Une colonne a été insérée} other {{count} colonnes ont été insérées}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {La colonne a été supprimée} other {{count} colonnes ont été supprimées}}',
  'fabric.editor.configFailedToLoad': 'Échec du chargement',
  'fabric.editor.configPanel.cancel': 'Annuler',
  'fabric.editor.configPanel.close': 'Fermer',
  'fabric.editor.configPanel.customSelect.createOption': 'Créer',
  'fabric.editor.configPanel.dateRange.custom.from': 'Du',
  'fabric.editor.configPanel.dateRange.custom.to': 'au',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Réduire',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Développer',
  'fabric.editor.configPanel.dateRange.option.custom': 'Personnalisée',
  'fabric.editor.configPanel.documentation': 'Documentation',
  'fabric.editor.configPanel.errorBoundary.note':
    "Nous avons informé l'équipe. Vous pouvez toujours modifier et publier cette page, ou consulter la console d'erreur pour en savoir plus.",
  'fabric.editor.configPanel.errorBoundary.title': "Une erreur s'est produite.",
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Impossible de combiner isMultiple avec style: radio',
  'fabric.editor.configPanel.formType.addField': 'Ajouter un champ',
  'fabric.editor.configPanel.formType.removeField': 'Supprimer le champ',
  'fabric.editor.configPanel.help': "Besoin d'aide ?",
  'fabric.editor.configPanel.invalid': 'Champ non valide',
  'fabric.editor.configPanel.required': 'Champ obligatoire',
  'fabric.editor.configPanel.submit': 'Enregistrer',
  'fabric.editor.contextPanel.panelLabel': 'Volet contextuel',
  'fabric.editor.copiedToClipboard': 'Copié !',
  'fabric.editor.copyToClipboard': 'Copier',
  'fabric.editor.cornerControl': 'Mettre le tableau en surbrillance',
  'fabric.editor.createComment': 'Commenter',
  'fabric.editor.createCommentDisabled':
    'Vous ne pouvez commenter que le texte, les titres, les émoticônes, les dates, les mentions, les liens et les états.',
  'fabric.editor.createCommentInvalid': 'Vous pouvez uniquement commenter du texte et des titres',
  'fabric.editor.customPanel': 'Volet personnalisé',
  'fabric.editor.customPanel.description': "Ajoutez une remarque avec une émoticône et un fond d'écran coloré",
  'fabric.editor.datasource.assetsObjects.description':
    'Insérer des objets depuis Actifs dans Jira Service Management grâce à la recherche et au filtrage',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Actifs',
  'fabric.editor.datasource.confluenceSearch': 'Insérer une liste Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Insérez une liste des résultats de recherche depuis Confluence grâce à la recherche, au filtrage et à la configuration améliorés.',
  'fabric.editor.datasource.jiraIssue': 'Tickets Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Insérez des tickets Jira depuis Jira Cloud grâce à la recherche, au filtrage et à la configuration améliorés.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Insérez des tickets Jira à partir de Jira Cloud grâce à la recherche, au filtrage et à la configuration améliorés.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Tickets Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Liste',
  'fabric.editor.datasourceTitle': 'Modifier la requête de recherche',
  'fabric.editor.date': 'Date',
  'fabric.editor.date.description': 'Ajouter une date depuis un calendrier',
  'fabric.editor.datePickerOpenedAlert':
    "La fenêtre contextuelle de modification de date s'est ouverte, appuyez sur la touche Tab pour y accéder",
  'fabric.editor.decision': 'Décision',
  'fabric.editor.decision.description': 'Enregistrer des décisions pour les suivre plus facilement',
  'fabric.editor.decisionPlaceholder': 'Ajoutez une décision…',
  'fabric.editor.decreaseElementSize': "Réduire la taille de l'élément",
  'fabric.editor.decreaseSize': 'Réduire la taille du tableau ou de la ressource',
  'fabric.editor.defaultAltText': 'Document',
  'fabric.editor.delete': 'Supprimer',
  'fabric.editor.description': 'Description',
  'fabric.editor.displayBlock': 'Afficher la carte',
  'fabric.editor.displayEmbed': 'Afficher comme intégré',
  'fabric.editor.displayInline': 'Afficher sur la même ligne',
  'fabric.editor.displayLink': 'Afficher sous forme de texte',
  'fabric.editor.displayOptionUnavailableInParentNode': "Cette option d'affichage n'est pas disponible dans {node}",
  'fabric.editor.displayText': 'Texte à afficher',
  'fabric.editor.distributeColumns': 'Répartir entre les colonnes',
  'fabric.editor.dragHandleZone': 'Activez la zone de la poignée de glissement',
  'fabric.editor.dropPlaceholderLabel': 'Document',
  'fabric.editor.ecombedDescription': "Affichez un aperçu interactif d'un lien",
  'fabric.editor.edit': 'Modifier',
  'fabric.editor.edit.datasource': 'Modifier la requête de recherche',
  'fabric.editor.edit.searchInput': 'Ajouter un lien',
  'fabric.editor.editAccessTitle': "Vous avez besoin de l'accès en modification",
  'fabric.editor.editAltText': 'Modifier le texte alternatif',
  'fabric.editor.editDatasourceStandalone': 'Modifier',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Modifier la requête de recherche',
  'fabric.editor.editDateText': 'Modifier la date',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Modifier la requête de recherche',
  'fabric.editor.editDropdownEditLinkTitle': 'Modifier le lien',
  'fabric.editor.editDropdownExpandIconLabel': 'Développer le menu déroulant',
  'fabric.editor.editDropdownTriggerTitle': 'Modifier',
  'fabric.editor.editLink': 'Modifier le lien',
  'fabric.editor.editMode.inviteToEditButton.title': 'Inviter à modifier',
  'fabric.editor.editStatusColor': "Modifier la couleur de l'état",
  'fabric.editor.editStatusText': "Modifier l'état",
  'fabric.editor.editableContentLabel': 'Contenu éditable',
  'fabric.editor.editorHelp': "Aide pour l'éditeur",
  'fabric.editor.editors': 'Éditeurs',
  'fabric.editor.elementBrowser.help': 'Aide',
  'fabric.editor.elementInsertSidePanel.title': 'Insérer',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Toutes',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Communication',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Contenu de Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Développement',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Contenu externe',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Mise en forme',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Média',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigation',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Rapports',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Visuels et images',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Utilisez un tableau blanc pour ajouter des éléments visuels à votre page',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Aucun résultat pour votre recherche',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Essayez de rechercher un autre terme ou découvrez de nouvelles apps pour les produits Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Explorer Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Aucun résultat pour votre recherche.} one {{count} suggestion disponible par défaut.} other {{count} suggestions disponibles par défaut.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Aucun résultat pour votre recherche.} one {{count} suggestion disponible pour le texte saisi.} other {{count} suggestions disponibles pour le texte saisi.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Entrer',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Rechercher',
  'fabric.editor.elementbrowser.sidebar.heading': 'Parcourir',
  'fabric.editor.embedTitle': 'Intégrer',
  'fabric.editor.embedToBlockCardWarning': "S'affiche sous forme de carte sur de petits écrans",
  'fabric.editor.emoji': 'Émoticône',
  'fabric.editor.emoji.description': 'Ajouter des émoticônes pour exprimer vos idées 🎉 et vos émotions 😄',
  'fabric.editor.emptyLink': 'Veuillez saisir un lien.',
  'fabric.editor.emptySearchResults': 'Aucun résultat trouvé.',
  'fabric.editor.emptySearchResultsSuggestion': 'Sélectionnez {buttonName} pour parcourir les éléments insérables.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Erreur',
  'fabric.editor.errorPanel': "Volet d'erreur",
  'fabric.editor.errorPanel.description': 'Signaler les erreurs dans un cadre coloré',
  'fabric.editor.expand': 'Développer',
  'fabric.editor.expand.description': 'Insérer une extension',
  'fabric.editor.expandAriaLabel': 'Donnez un titre à cette expansion',
  'fabric.editor.expandDefaultTitle': 'Cliquez ici pour développer...',
  'fabric.editor.expandNode': 'Développer le contenu',
  'fabric.editor.expandPlaceholder': 'Donnez un titre à cette zone plus large…',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Si vous supprimez {nodeName}, tous les éléments qui y sont connectés deviendront inexploitables.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Suppression',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Supprimer',
  'fabric.editor.extension.deleteElementTitle': 'Supprimer un élément',
  'fabric.editor.extension.sourceNoTitledName': 'cet élément',
  'fabric.editor.extensions.config-panel.save-indicator':
    'Tous les changements sont toujours enregistrés automatiquement',
  'fabric.editor.externalExtensionsHeading': 'Apps',
  'fabric.editor.externalMediaFile': 'Fichier multimédia externe',
  'fabric.editor.failed_to_upload': 'Échec du chargement',
  'fabric.editor.feedbackDialog': 'Donner votre avis',
  'fabric.editor.feedbackDialog.description': "Faites-nous part de votre expérience avec l'éditeur de cloud",
  'fabric.editor.find': 'Rechercher',
  'fabric.editor.findNext': 'Suivant',
  'fabric.editor.findPrevious': 'Précédent',
  'fabric.editor.findReplaceToolbarButton': 'Rechercher et remplacer',
  'fabric.editor.fiveColumns': 'Disposition en 5 colonnes',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Annuler',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Supprimer également les éléments connectés',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 élément connecté)} other {{name} (+{amount,number} éléments connectés)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Voulez-vous vraiment continuer ?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    "Les commandes de la barre d'outils flottante sont ouvertes",
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': "Barre d'outils flottante",
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Options de disposition',
  'fabric.editor.floatingToolbar.scrollLeft': 'Faire défiler vers la gauche',
  'fabric.editor.floatingToolbar.scrollRight': 'Faire défiler vers la droite',
  'fabric.editor.focusTableResizeHandle': 'Focus sur la poignée de redimensionnement des tableaux',
  'fabric.editor.fourColumns': 'Disposition en 4 colonnes',
  'fabric.editor.headerColumn': "Colonne de l'en-tête",
  'fabric.editor.headerRow': "Ligne d'en-tête",
  'fabric.editor.heading1': 'En-tête 1',
  'fabric.editor.heading1Description': 'Utilisez ceci pour définir un titre principal',
  'fabric.editor.heading2': 'En-tête 2',
  'fabric.editor.heading2Description': 'Utilisez ceci pour définir des sections principales',
  'fabric.editor.heading3': 'En-tête 3',
  'fabric.editor.heading3Description': 'Utilisez ceci pour définir des sous-sections et des titres de groupe',
  'fabric.editor.heading4': 'En-tête 4',
  'fabric.editor.heading4Description': 'Utilisez ceci pour définir des titres de niveau inférieur',
  'fabric.editor.heading5': 'En-tête 5',
  'fabric.editor.heading5Description': 'Utilisez ceci pour regrouper des éléments de liste',
  'fabric.editor.heading6': 'En-tête 6',
  'fabric.editor.heading6Description': 'Utilisez ceci pour définir un sous-titre',
  'fabric.editor.headingLink.ascOrderLabel': 'Trier la colonne de Z à A',
  'fabric.editor.headingLink.descOrderLabel': 'Effacer le tri',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Ticket',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Ticket',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Page',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Tâche',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Impossible de trier un tableau comportant des cellules fusionnées',
  'fabric.editor.headingLink.noOrderLabel': 'Trier la colonne de A à Z',
  'fabric.editor.help': 'Aide',
  'fabric.editor.help.description': 'Parcourir les raccourcis clavier et les options de réduction',
  'fabric.editor.helpDialogTips': 'Appuyez sur {keyMap} pour ouvrir rapidement cette boîte de dialogue à tout moment',
  'fabric.editor.highlight': 'Couleur de surbrillance',
  'fabric.editor.highlight.removeColor': 'Supprimer la couleur',
  'fabric.editor.highlightColor': 'Activer ou désactiver la palette de couleurs de surbrillance',
  'fabric.editor.highlightFloatingToolbar': 'Surligner',
  'fabric.editor.horizontalRule': 'Séparateur',
  'fabric.editor.horizontalRule.description': 'Séparer du contenu avec une ligne horizontale',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Coller ou rechercher un lien',
  'fabric.editor.hyperlink.searchLinkAriaDescription':
    'Les suggestions apparaîtront au fur et à mesure que vous saisissez du texte dans le champ',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {aucun résultat} one {{count,number} résultat trouvé} other {{count,number} résultats trouvés}}',
  'fabric.editor.hyperlink.textVisibleLabel': "Texte d'affichage (facultatif)",
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Coller ou rechercher un lien',
  'fabric.editor.image': 'Image',
  'fabric.editor.image.fullWidthLabel': 'Pleine largeur',
  'fabric.editor.imageBorderBold': 'Gras',
  'fabric.editor.imageBorderColor': 'Couleur',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': "Menu déroulant des options de couleurs de la bordure de l'image",
  'fabric.editor.imageBorderMedium': 'Moyenne',
  'fabric.editor.imageBorderOptions': 'Options de bordure',
  'fabric.editor.imageBorderSize': 'Taille',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': "Menu déroulant des options de tailles de la bordure de l'image",
  'fabric.editor.imageBorderSubtle': 'Subtile',
  'fabric.editor.improvement': 'Amélioration',
  'fabric.editor.increaseElementSize': "Augmenter la taille de l'élément",
  'fabric.editor.increaseSize': 'Augmenter la taille du tableau ou de la ressource',
  'fabric.editor.indent': 'Retrait positif',
  'fabric.editor.info': 'Informations',
  'fabric.editor.infoPanel': "Volet d'informations",
  'fabric.editor.infoPanel.description': 'Mettre en valeur des informations dans un cadre coloré',
  'fabric.editor.inlineConfigureLink': 'Configurer le lien',
  'fabric.editor.inlineDescription': 'Affichez le lien sous forme de texte sur la même ligne',
  'fabric.editor.inlineGoToLink': 'Suivre le lien',
  'fabric.editor.inlineOverlay': 'Configurer',
  'fabric.editor.inlineTitle': 'Sur la même ligne',
  'fabric.editor.inputQueryAssistiveTxt':
    "Lorsque les résultats de la saisie semi-automatique sont disponibles, utilisez les flèches vers le haut et le bas pour les passer en revue, et appuyez sur Entrée pour en sélectionner un. Les utilisateurs d'appareils tactiles peuvent parcourir les résultats en touchant l'écran ou en le balayant.",
  'fabric.editor.insertColumn': 'Insérer une colonne à droite',
  'fabric.editor.insertColumnDrag': 'Insérer une colonne',
  'fabric.editor.insertMenu': 'Insérer des éléments',
  'fabric.editor.insertRightRail.close': 'Fermer',
  'fabric.editor.insertRightRail.title': 'Insérer',
  'fabric.editor.insertRow': 'Insérer une ligne en dessous',
  'fabric.editor.insertRowDrag': 'Insérer une ligne',
  'fabric.editor.insertTableColumn': 'Insérer une colonne dans le tableau',
  'fabric.editor.insertTableRow': 'Insérer une ligne dans le tableau',
  'fabric.editor.invalidDateError': 'Saisissez une date valide',
  'fabric.editor.invalidLink': 'Veuillez saisir un lien valide.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Inviter un coéquipier à rejoindre {productName}} trusted {Inviter un coéquipier à rejoindre {productName}} other {Ajouter un coéquipier à {productName}}}',
  'fabric.editor.italic': 'Italique',
  'fabric.editor.keyboardShortcuts': 'Raccourcis clavier',
  'fabric.editor.layout.columnOption': '{count, plural, one {Colonne} other {{count} colonnes}}',
  'fabric.editor.layout.controls.placeholder': 'Saisissez / pour insérer',
  'fabric.editor.layout.placeholder': 'Ajouter du contenu',
  'fabric.editor.layout.resizeLayout': 'Redimensionner la disposition',
  'fabric.editor.layoutFixedWidth': 'Centrer à nouveau',
  'fabric.editor.layoutFullWidth': 'Passer en mode pleine largeur',
  'fabric.editor.layoutStateFixedWidth': 'Centré',
  'fabric.editor.layoutStateFullWidth': 'Pleine largeur',
  'fabric.editor.layoutStateWide': 'Large',
  'fabric.editor.layoutWide': 'Passer en mode élargi',
  'fabric.editor.leftSidebar': 'Disposition de la barre latérale de gauche',
  'fabric.editor.link': 'Lien',
  'fabric.editor.link.description': 'Insérer un lien',
  'fabric.editor.linkAddress': 'Adresse du lien',
  'fabric.editor.linkPlaceholder': 'Coller un lien',
  'fabric.editor.lists': 'Listes',
  'fabric.editor.listsFormat': 'Mise en forme de liste',
  'fabric.editor.lockColumns': 'Largeurs de colonne fixes',
  'fabric.editor.longEmptyNodePlaceholderText': 'Saisissez / pour insérer des éléments',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Respecter la casse',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {La largeur du média a été réduite à {newMediaWidth,number} pixel.} other {La largeur du média a été réduite à {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {La largeur du média a été augmentée à {newMediaWidth,number} pixel.} other {La largeur du média a été augmentée à {newMediaWidth,number} pixels.}}',
  'fabric.editor.media.MediaWidthIsMin': 'La taille des médias a été réduite au minimum',
  'fabric.editor.media.insert.cancel': 'Annuler',
  'fabric.editor.media.insert.fileTabTitle': 'Fichier',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    "Malheureusement, nous ne pouvons pas ajouter le lien vers cette image. Téléchargez l'image, puis faites-la glisser sur la page.",
  'fabric.editor.media.insert.fromUrlWarning':
    "Cette image n'est peut-être pas visible pour les autres en raison de restrictions source. Envisagez plutôt d'importer le fichier.",
  'fabric.editor.media.insert.insert': 'Insérer',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Lien non valide',
  'fabric.editor.media.insert.linkTabTitle': 'Lien',
  'fabric.editor.media.insert.loadPreview': "Charger l'aperçu",
  'fabric.editor.media.insert.localFileErrorMessage': 'Impossible de charger ce fichier.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    "Erreur de chargement du fichier. Vérifiez le chemin d'accès au fichier ou le réseau.",
  'fabric.editor.media.insert.mediaAlt': 'Aperçu du fichier image ou vidéo importé',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Sélecteur de contenu multimédia',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Coller un lien pour importer',
  'fabric.editor.media.insert.upload': 'Importer',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'La taille des médias a été augmentée au maximum',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Redimensionner',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Fermer',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'saisie de la hauteur',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Hauteur',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Largeur maximale : {maxWidth} pixels',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Largeur',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Largeur maximale : {maxWidth} pixels',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Convertir en pixels',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': "Passer d'un pourcentage à une taille de pixels fixe",
  'fabric.editor.media.pixelEntry.submitButtonText': 'Enregistrer',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'La validation de la largeur a échoué',
  'fabric.editor.mediaAddLink': 'Ajouter un lien',
  'fabric.editor.mediaFiles': 'Image, vidéo ou fichier',
  'fabric.editor.mediaFiles.description': "Ajoutez des images et d'autres fichiers à votre page",
  'fabric.editor.mediaGroupDeleteLabel': 'Supprimer',
  'fabric.editor.media_change_mediainline_caption_warn': 'Contextuel (la légende sera supprimée)',
  'fabric.editor.media_change_mediainline_default': 'Contextuel',
  'fabric.editor.media_change_mediasingle': "Taille d'origine",
  'fabric.editor.mention': 'Mention',
  'fabric.editor.mention.description': 'Mentionner une personne pour lui envoyer une notification',
  'fabric.editor.mentionNode.label': 'Utilisateur mentionné',
  'fabric.editor.mentionsAddLabel': 'icône-ajout',
  'fabric.editor.mentionsIconLabel': 'Mentionner',
  'fabric.editor.mergeCells': 'Fusionner les cellules',
  'fabric.editor.moreFormatting': 'Plus de formatage',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Déplacer la colonne vers la gauche} other {Déplacer les colonnes vers la gauche}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Déplacer la colonne vers la droite} other {Déplacer les colonnes vers la droite}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Déplacer la ligne vers le bas} other {Déplacer les lignes vers le bas}}',
  'fabric.editor.moveRowUp':
    '{0, plural, one {Déplacer la ligne vers le haut} other {Déplacer les lignes vers le haut}}',
  'fabric.editor.navigate.toolbar.askAI': "Demander à l'IA",
  'fabric.editor.navigate.toolbar.editor': "Accéder à la barre d'outils de l'éditeur",
  'fabric.editor.navigate.toolbar.floating': "Accéder à la barre d'outils flottante",
  'fabric.editor.noPermissionToAddComment':
    "{contentType, select, blogpost {Vous n'êtes pas autorisé à ajouter des commentaires à ce billet de blog} page {Vous n'êtes pas autorisé à ajouter des commentaires à cette page} other {Vous n'êtes pas autorisé à ajouter des commentaires à cette page}}",
  'fabric.editor.noResultsFound': 'Aucun résultat',
  'fabric.editor.noSearchResults': 'Aucun résultat de recherche',
  'fabric.editor.normal': 'Texte normal',
  'fabric.editor.note': 'Note',
  'fabric.editor.notePanel': 'Volet de notes',
  'fabric.editor.notePanel.description': 'Ajouter une note dans un cadre coloré',
  'fabric.editor.numberedColumn': 'Colonne numérotée',
  'fabric.editor.off': '{formattingType} désactivé(e)',
  'fabric.editor.on': '{formattingType} activé',
  'fabric.editor.openButtonTitle': 'Ouvrir',
  'fabric.editor.openCellOptions': 'Ouvrir les options des cellules',
  'fabric.editor.openLink': 'Ouvrir le lien dans un nouvel onglet',
  'fabric.editor.openPreviewPanel': "Ouvrir le panneau d'aperçu",
  'fabric.editor.orderedList': 'Liste numérotée',
  'fabric.editor.orderedList.description': 'Créer une liste ordonnée',
  'fabric.editor.other': 'Autres…',
  'fabric.editor.outdent': 'Retrait négatif',
  'fabric.editor.overflowMenuViewMore': 'Voir plus',
  'fabric.editor.pageActionsLabel': 'Actions de page',
  'fabric.editor.panel': 'Volet',
  'fabric.editor.panel.backgroundColor': "Couleur d'arrière-plan",
  'fabric.editor.panel.custom': 'Personnalisée',
  'fabric.editor.panel.emoji': 'Ajouter une émoticône',
  'fabric.editor.panel.panelsGroup': 'Types de panneaux',
  'fabric.editor.panelButtonTitle': 'Volet',
  'fabric.editor.pasteOptions': 'Options de collage',
  'fabric.editor.pastePlainText': 'Coller le texte brut',
  'fabric.editor.placeholderAltText': 'Décrire cette image avec un texte alternatif',
  'fabric.editor.placeholderText': 'Texte fictif',
  'fabric.editor.placeholderText.description': 'Insérer un espace réservé pour du texte dans la page',
  'fabric.editor.placeholderTextPlaceholder': "Ajouter le texte de l'espace réservé",
  'fabric.editor.plainText': 'Utiliser du texte brut',
  'fabric.editor.preferencesLink': 'Préférences des liens',
  'fabric.editor.previewButtonTitle': 'Afficher un aperçu',
  'fabric.editor.quickInsert': 'Insertion rapide',
  'fabric.editor.recordLoomShortTitle': 'Enregistrer',
  'fabric.editor.recordVideo': 'Enregistrer une vidéo Loom',
  'fabric.editor.recordVideo.description': 'Enregistrez et partagez votre écran et votre opinion',
  'fabric.editor.redo': 'Rétablir',
  'fabric.editor.remove': 'Supprimer',
  'fabric.editor.removeColumns': '{0, plural, one {Supprimer la colonne} other {Supprimer les colonnes}}',
  'fabric.editor.removeEmoji': "Supprimer l'émoticône",
  'fabric.editor.removeImageBorder': 'Supprimer la bordure',
  'fabric.editor.removeRows': '{0, plural, one {Supprimer la ligne} other {Supprimer les lignes}}',
  'fabric.editor.replace': 'Remplacer',
  'fabric.editor.replaceAll': 'Remplacer tout',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} correspondance remplacée} other {{numberOfMatches,number} correspondances remplacées}}',
  'fabric.editor.replaceWith': 'Remplacer par',
  'fabric.editor.requestToEdit': 'Demander le droit de modifier',
  'fabric.editor.requestToEditDescription':
    "Lorsque vous demandez l'accès, le propriétaire de la page reçoit une notification.",
  'fabric.editor.requestToEditDismiss': 'Ignorer',
  'fabric.editor.resizeHandle': 'Redimensionner la poignée',
  'fabric.editor.resultsCount': '{selectedMatchPosition} sur {totalResultsCount}',
  'fabric.editor.richText': 'Utiliser du texte enrichi',
  'fabric.editor.rightSidebar': 'Disposition de la barre latérale de droite',
  'fabric.editor.rowControl': 'Mettre la ligne en surbrillance',
  'fabric.editor.rowDragHandle': 'Options de ligne',
  'fabric.editor.rowMovedDown': 'Ligne déplacée vers le bas à la position {index} sur {total}',
  'fabric.editor.rowMovedUp': 'Ligne déplacée vers le haut à la position {index} sur {total}',
  'fabric.editor.rowSelected': 'Ligne {index} sur {total} sélectionnée',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Une ligne a été insérée} other {{count} lignes ont été insérées}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {La ligne a été supprimée} other {{count} lignes ont été supprimées}}',
  'fabric.editor.saveButton': 'Enregistrer',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} résultat de recherche disponible. Utilisez les flèches vers le haut et vers le bas pour parcourir les options. Appuyez sur Entrée pour en sélectionner une.} other {{itemsLength,number} résultats de recherche disponibles. Utilisez les flèches vers le haut et vers le bas pour parcourir les options. Appuyez sur Entrée pour en sélectionner une.}}',
  'fabric.editor.selectColumnResize': 'Sélectionner le redimensionnement de la colonne',
  'fabric.editor.selectLanguage': 'Sélectionner le langage',
  'fabric.editor.selectTableColumn': 'Sélectionner une colonne du tableau',
  'fabric.editor.selectTableRow': 'Sélectionner une ligne du tableau',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Sélectionner une app',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': "Plus d'options",
  'fabric.editor.settingsLinks': 'Accéder aux préférences des liens',
  'fabric.editor.shortEmptyNodePlaceholderText': 'Saisissez / pour insérer',
  'fabric.editor.shortcut': 'Raccourci de texte',
  'fabric.editor.single': 'Disposition en colonne unique',
  'fabric.editor.singleColumns': 'Disposition en 1 colonne',
  'fabric.editor.sortColumnASC': 'Trier la colonne de A à Z',
  'fabric.editor.sortColumnDESC': 'Trier la colonne de Z à A',
  'fabric.editor.sortColumnDecreasing': 'Trier par ordre décroissant',
  'fabric.editor.sortColumnIncreasing': 'Trier par ordre croissant',
  'fabric.editor.splitCell': 'Partager la cellule',
  'fabric.editor.status': 'État',
  'fabric.editor.status.description': "Ajouter une étiquette d'état personnalisée",
  'fabric.editor.statusEditorLabel': "Éditeur d'état",
  'fabric.editor.statusPickerOpenedAlert':
    "La fenêtre contextuelle de modification d'état s'est ouverte. Appuyez sur la touche de tabulation pour y accéder.",
  'fabric.editor.statusPlaceholder': 'Définir un état',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Barrer',
  'fabric.editor.subTask': 'Sous-tâche',
  'fabric.editor.subscript': 'Indice',
  'fabric.editor.subscript.off.superscript.on': 'Indice désactivé, exposant activé',
  'fabric.editor.success': 'Opération réussie',
  'fabric.editor.successPanel': 'Panneau de réussite',
  'fabric.editor.successPanel.description': 'Ajouter des astuces dans un cadre coloré',
  'fabric.editor.superscript': 'Exposant',
  'fabric.editor.superscript.off.subscript.on': 'Exposant désactivé, indice activé',
  'fabric.editor.supportAltText':
    "Le texte alternatif est utile pour les personnes utilisant des lecteurs d'écran en raison d'une déficience visuelle.",
  'fabric.editor.table': 'Tableau',
  'fabric.editor.table.description': 'Insérer un tableau',
  'fabric.editor.tableAlignmentOptions': "Options d'alignement",
  'fabric.editor.tableFullWidthLabel': 'Pleine largeur',
  'fabric.editor.tableHeader.sorting.asc': 'Tri par ordre croissant appliqué',
  'fabric.editor.tableHeader.sorting.default': 'Trier la colonne',
  'fabric.editor.tableHeader.sorting.desc': 'Tri par ordre décroissant appliqué',
  'fabric.editor.tableHeader.sorting.invalid': 'Impossible de trier un tableau comportant des cellules fusionnées',
  'fabric.editor.tableHeader.sorting.no': 'Aucun tri appliqué à la colonne',
  'fabric.editor.tableOptions': 'Options du tableau',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {La largeur du tableau a été réduite à {newWidth,number} pixel.} other {La largeur du tableau a été réduite à {newWidth,number} pixels.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {La largeur du tableau a été augmentée à {newWidth,number} pixel.} other {La largeur du tableau a été augmentée à {newWidth,number} pixels.}}',
  'fabric.editor.tableScrollRegion': 'Zone de défilement du tableur',
  'fabric.editor.tableSelector': 'Taille du tableau',
  'fabric.editor.tableSelector.description':
    'Ajouter un tableau en utilisant une fenêtre contextuelle pour sélectionner une taille personnalisée',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} par {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Sélecteur de taille de tableau',
  'fabric.editor.tables.adjustColumn': 'Ajuster la colonne',
  'fabric.editor.tables.columnResizeLast': 'Vous ne pouvez redimensionner cette colonne que vers la gauche.',
  'fabric.editor.tables.columnResizeOverflow':
    'Vous ne pouvez redimensionner cette colonne que si le tableau comporte une barre de défilement.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {La largeur de la colonne a été modifiée à {width} pixel} other {La largeur de la colonne a été modifiée à {width} pixels}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Si vous supprimez {nodeName}, tous les éléments qui y sont connectés deviendront inexploitables.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Supprimer',
  'fabric.editor.tables.resizeStop': 'Redimensionnement interrompu',
  'fabric.editor.tables.resizeTable': 'Redimensionner le tableau',
  'fabric.editor.tables.startedColumnResize': 'Redimensionnement de la colonne lancé',
  'fabric.editor.task': 'Tâche',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Marquer la tâche comme terminée',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Marquer la tâche comme non terminée',
  'fabric.editor.taskList': 'Liste de tâches',
  'fabric.editor.taskPlaceholder': "Saisissez votre action, utilisez « @ » pour l'assigner à quelqu'un.",
  'fabric.editor.text.formatting.off': 'Mise en forme du texte désactivée',
  'fabric.editor.textColor': 'Couleur de texte {selectedColorName}',
  'fabric.editor.textColorHighlightTooltip': 'Couleur du texte et de surbrillance',
  'fabric.editor.textColorTooltip': 'Couleur du texte',
  'fabric.editor.textFormat': 'Mettre en forme le texte',
  'fabric.editor.textFormatting': 'Mise en forme de texte',
  'fabric.editor.textStyles': 'Styles de texte {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Styles de texte',
  'fabric.editor.threeColumns': 'Disposition en 3 colonnes',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Disposition en trois colonnes avec barre latérale à gauche',
  'fabric.editor.threeColumnsWithRightSidebars': 'Disposition en trois colonnes avec barre latérale à droite',
  'fabric.editor.threeColumnsWithSidebars': 'Disposition en trois colonnes avec barres latérales',
  'fabric.editor.time.ago': 'Il y a',
  'fabric.editor.time.updated': 'Mise à jour',
  'fabric.editor.time.viewed': 'Consultation',
  'fabric.editor.toolbarAppears': "La barre d'outils apparaît",
  'fabric.editor.toolbarLabel': 'Éditeur',
  'fabric.editor.toolbarMediaTitle': 'Ajoutez une image, une vidéo ou un fichier',
  'fabric.editor.toolbarPositionFixedAtTop': 'Fixée en haut',
  'fabric.editor.toolbarPositionInline': 'Alignée avec le texte',
  'fabric.editor.toolbarPositionPinedAtTop': "Libérer la barre d'outils",
  'fabric.editor.toolbarPositionUnpined': "Épingler la barre d'outils en haut",
  'fabric.editor.toolbarPositionUnpinnedConcise': "Épingler la barre d'outils en haut",
  'fabric.editor.tooltip.blockPanel': 'un panneau',
  'fabric.editor.tooltip.bulletList': 'une liste',
  'fabric.editor.tooltip.decisionList': 'une liste de décisions',
  'fabric.editor.tooltip.defaultBlockNode': 'un nœud de bloc',
  'fabric.editor.tooltip.nestedExpand': 'une extension imbriquée',
  'fabric.editor.tooltip.taskList': 'une mesure',
  'fabric.editor.turnInto': 'Transformer en',
  'fabric.editor.twoColumns': 'Disposition en 2 colonnes',
  'fabric.editor.typeAhead.popupLabel': 'Résultats de la saisie semi-automatique',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Commencez à taper pour rechercher ou filtrer les options de raccourci',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Rechercher',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Raccourcis pour les insertions et le formatage',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Aucun résultat disponible. Veuillez réessayer.',
  'fabric.editor.typeAheadErrorFallbackHeading': "Une erreur s'est produite",
  'fabric.editor.typeahead.emojiInputLabel': "Commencez à taper pour rechercher ou filtrer les options d'émoticône",
  'fabric.editor.typeahead.emojiListItemLabel': "Texte de l'émoticône {name} et du raccourci {shortcut}",
  'fabric.editor.typeahead.emojiPopupLabel': "Raccourcis d'émoticône",
  'fabric.editor.typeahead.mentionInputLabel': 'Commencez à taper pour rechercher les utilisateurs à mentionner',
  'fabric.editor.typeahead.mentionPopupLabel': 'Utilisateurs que vous pouvez mentionner',
  'fabric.editor.typeahead.metionListItemLabel': 'Utilisateur {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Impossible de charger ce contenu',
  'fabric.editor.unableToOpenLink': "Impossible d'ouvrir ce lien",
  'fabric.editor.underline': 'Souligner',
  'fabric.editor.undo': 'Annuler',
  'fabric.editor.unknown.label': 'Inconnu',
  'fabric.editor.unlink': 'Dissocier',
  'fabric.editor.unorderedList': 'Liste à puces',
  'fabric.editor.unorderedList.description': 'Créer une liste non ordonnée',
  'fabric.editor.unsupportedBlockContent': "Cet éditeur ne prend pas en charge l'affichage de ce contenu",
  'fabric.editor.unsupportedContentTooltip':
    "Le contenu n'est pas disponible dans cet éditeur, il sera conservé lorsque vous le modifierez et l'enregistrerez",
  'fabric.editor.unsupportedInlineContent': 'Contenu non pris en charge',
  'fabric.editor.upDown':
    'En utilisant les flèches haut et bas dans le champ de saisie suivant, la date sera mise à jour ci-dessous',
  'fabric.editor.url': "Afficher l'URL",
  'fabric.editor.urlDescription': "Affichez le lien sous forme d'URL",
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Utiliser Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Afficher et ajouter des commentaires',
  'fabric.editor.viewCommentOnMedia': 'Afficher les commentaires',
  'fabric.editor.viewMore': 'Voir plus',
  'fabric.editor.viewMoreAriaLabel': 'Afficher tous les éléments',
  'fabric.editor.visit': 'Ouvrir le lien dans une nouvelle fenêtre',
  'fabric.editor.warning': 'Avertissement',
  'fabric.editor.warningPanel': "Panneau d'avertissement",
  'fabric.editor.warningPanel.description': "Ajouter une note d'avertissement dans un cadre coloré",
  'fabric.editor.wrapLeft': 'Ajuster vers la gauche',
  'fabric.editor.wrapRight': 'Ajuster vers la droite',
  'fabric.emoji.label': 'Émoticône',
  'fabric.theme.blue': 'Bleu',
  'fabric.theme.bold-blue': 'Bleu vif',
  'fabric.theme.bold-gray': 'Gris vif',
  'fabric.theme.bold-green': 'Vert vif',
  'fabric.theme.bold-magenta': 'Magenta vif',
  'fabric.theme.bold-orange': 'Orange vif',
  'fabric.theme.bold-purple': 'Violet vif',
  'fabric.theme.bold-red': 'Rouge vif',
  'fabric.theme.bold-teal': 'Bleu-vert vif',
  'fabric.theme.bold-yellow': 'Jaune vif',
  'fabric.theme.bolder-blue': 'Bleu plus vif',
  'fabric.theme.bolder-gray': 'Gris plus vif',
  'fabric.theme.bolder-green': 'Vert plus vif',
  'fabric.theme.bolder-magenta': 'Magenta plus vif',
  'fabric.theme.bolder-orange': 'Orange plus vif',
  'fabric.theme.bolder-purple': 'Violet plus vif',
  'fabric.theme.bolder-red': 'Rouge plus vif',
  'fabric.theme.bolder-teal': 'Bleu-vert plus vif',
  'fabric.theme.bolder-yellow': 'Jaune plus vif',
  'fabric.theme.dark-blue': 'Bleu foncé',
  'fabric.theme.dark-gray': 'Gris foncé',
  'fabric.theme.dark-green': 'Vert foncé',
  'fabric.theme.dark-purple': 'Violet foncé',
  'fabric.theme.dark-red': 'Rouge foncé',
  'fabric.theme.dark-teal': 'Bleu-vert foncé',
  'fabric.theme.dark-yellow': 'Jaune foncé',
  'fabric.theme.default': 'Par défaut',
  'fabric.theme.gray': 'Gris',
  'fabric.theme.green': 'Vert',
  'fabric.theme.light-blue': 'Bleu clair',
  'fabric.theme.light-gray': 'Gris clair',
  'fabric.theme.light-green': 'Vert clair',
  'fabric.theme.light-purple': 'Violet clair',
  'fabric.theme.light-red': 'Rouge clair',
  'fabric.theme.light-teal': 'Bleu-vert clair',
  'fabric.theme.light-yellow': 'Jaune clair',
  'fabric.theme.lime': 'Citron vert',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Pas de surbrillance',
  'fabric.theme.orange': 'Orange',
  'fabric.theme.purple': 'Violet',
  'fabric.theme.red': 'Rouge',
  'fabric.theme.subtle-blue': 'Bleu pastel',
  'fabric.theme.subtle-gray': 'Gris pastel',
  'fabric.theme.subtle-green': 'Vert pastel',
  'fabric.theme.subtle-magenta': 'Magenta pastel',
  'fabric.theme.subtle-orange': 'Orange pastel',
  'fabric.theme.subtle-purple': 'Violet pastel',
  'fabric.theme.subtle-red': 'Rouge pastel',
  'fabric.theme.subtle-teal': 'Bleu-vert pastel',
  'fabric.theme.subtle-yellow': 'Jaune pastel',
  'fabric.theme.teal': 'Bleu-vert',
  'fabric.theme.white': 'Blanc',
  'fabric.theme.yellow': 'Jaune',
  'fabrid.editor.rowNumbers': 'Numéros de ligne',
  'rovo.agents.dropdown.title': 'Agents',
  'rovo.agents.dropdown.viewAgents.label': 'Afficher tous les agents',
};
